export default "__VITE_ASSET__BraXmepk__"